import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_ALERTS,DOWNLOAD_ALERTS } from 'actions/alerts';

function* fetchAlerts(action) {
  try {
    const response = yield call(API.getAlerts, action.payload);
    
    yield put({ type: FETCH_ALERTS.SUCCESS, payload: response.data });
    if (action.cb) {
      action.cb(response);
    }
  } catch (e) {
    yield put({ type: FETCH_ALERTS.FAIL, payload: { error: e } });
  }
}

function* downloadAlerts(action) {
  try {
    const response = yield call(API.downloadAlerts, action.payload);
    yield put({ type: DOWNLOAD_ALERTS.SUCCESS, payload: response.data });
    if (action.cb) {
      action.cb(response);
    }
  } catch (e) {
    yield put({ type: DOWNLOAD_ALERTS.FAIL, payload: { error: e } });
  }
}

function* alerts() {
  yield takeLatest(FETCH_ALERTS.REQUEST, fetchAlerts);
  yield takeLatest(DOWNLOAD_ALERTS.REQUEST, downloadAlerts);
}
export default alerts;
